import getEnv from "@/config/env";
import { retrieveProdInformation } from "@/helpers/helper";

let departmentPhones = {
    "KENKO" : [
        "08059737076",
        "08093673667",
        "07077990902",
        "07077903261",
        "07077903252",
        "07077990961",
        "09044551896",
        "09044552263",
        "09044552412",
        "09044552441",
        "09044911966",
        "09044913022",
        "09044913046",
        "07077903263",
    ],
    "TAS": [
        "08068457999",
        "09044551841",
        "07088171963",
        "07021664627",
        "08059829239",
        "08059737073",
        "07077903262",
        "07088177889",
    ],
    "STC": [
        "07077990884",
        "08068457999",
        "07077990930",
        "09044551841",
        "07088171963",
        "08059737073",
    ],
    "KURASHI": [
        "08068457999",
        "09044551841",
        "07088171963",
        "07021664627",
        "08059737073",
        "07077990891",
        "07077903259",
        "07077903254",
    ],
    "CCG": [
        "07077990884",
        "08068457999",
        "09044551841",
        "07088171963",
        "08059737073",
        "09044551838",
    ],
};

const SHEET_ID = getEnv("VUE_APP_SHEET_ID") || '1U4af0bCt_C_WtsLs2mVWbPOgFJFEsw5loZMrb85ojtg';
const GID = getEnv("VUE_APP_DEPARTMENT_PHONE_GID") || '1542352612';

try {
  const data = await retrieveProdInformation(SHEET_ID, GID);

  if (!data?.table?.rows || !Array.isArray(data.table.rows)) {
    console.warn("Invalid Google Sheet response:", data);
  } else {
    const deptPhones = {};
    
    const headerRow = data.table.rows[0].c.map(cell => cell?.v || "");
    
    headerRow.forEach(dept => {
      if (dept) deptPhones[dept] = [];
    });

    data.table.rows.slice(1).forEach(row => {
      row.c.forEach((cell, index) => {
        const dept = headerRow[index];
        const phone = cell?.v?.toString().trim();
        if (dept && phone) {
          deptPhones[dept].push(phone);
        }
      });
    });

    if (Object.keys(deptPhones).length > 0) {
      departmentPhones = deptPhones;
    }
  }
} catch (error) {
  console.error("Failed to load department phone info:", error);
}

export function getDepartmentPhones(departmentCode) {
    return departmentPhones[departmentCode] || [];
}